module.exports = __webpack_public_path__ + "static/use-case-1-content-4-f6800a85857521bd3eb479d3503849bb.png";